import { Message } from 'element-ui';
import {showLoading,hideLoading} from '@/js/loading.js';
import {getUserInvoice} from '@/assets/request/InvoiceRequest';
export default {
    state:{
        AskForAnInvoiceShow:false,
        selectedOrderId:null,
        isClose:false,
        list:[],
    },
    mutations:{
        refreshInvoiceList(state,{list}){
            state.list=list;
        },
        toggleAskForInvoiceShow(state,bool){
            state.AskForAnInvoiceShow = bool;
        },
        updateSelectedOrderId(state,id){
            state.selectedOrderId = id;
            state.isClose=false;
        },
        updateSelectedDownOrderId(state,{id,isClose}){
            state.selectedOrderId = id;
            state.isClose=isClose;
        },
    },
    actions:{
        async getInvoiceListRequest({commit}){
            showLoading();
            const list = await getUserInvoice().catch(r=>{
                hideLoading();
                Message.error('获取发票异常');
                console.trace({
                    message:'获取发票异常',
                    r
                });
            });            
            if(list.status !== 200) return hideLoading(),Message.warning(list.statusText);
            if(list.data.code!=200) return hideLoading(),Message.warning(list.data.msg);
            commit('refreshInvoiceList',{list:list.data.data});hideLoading();
        }
    },
    getters:{
        getInvoiceList:s=>s.list,
    }
}